const getters = {
    navigationString: state => {
      let result = '';
      if (state.navigation.search) {
        result = `filter=${state.navigation.search}&`;
      }
      if (state.navigation.orderField) {
        result = `${result}order=${state.navigation.orderField}&mode=${state.navigation.orderMode}&`;
      }
      if (state.navigation.customFilter) {
        result = `${result}${state.navigation.customFilter}&`;
      }
      if (state.navigation.extraParams) {
        result = `${result}${state.navigation.extraParams}`;
      }
      return result;
    },
};

export default getters;
